<button
  pButton
  type="button"
  icon="pi pi-info-circle"
  [rounded]="true"
  [text]="true"
  severity="info"
  class="feature-guide-btn"
  [pTooltip]="tooltip"
  tooltipPosition="right"
  (click)="open()"></button>

<p-dialog
  [header]="title"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '520px' }"
  [draggable]="false">
  <div class="schedule-guide">
    @if (intro) {
      <p class="guide-intro">{{ intro }}</p>
    }
    @for (group of groups; track group.heading) {
      <div class="guide-acc">
        <button type="button" class="guide-acc-head" [class.open]="openGroup === group.heading"
                (click)="toggleGroup(group.heading)">
          <span>{{ group.heading }}</span>
          <i class="pi" [class.pi-chevron-down]="openGroup !== group.heading" [class.pi-chevron-up]="openGroup === group.heading"></i>
        </button>
        @if (openGroup === group.heading) {
          <div class="guide-acc-body">
            @for (item of group.items; track item.title) {
              <div class="guide-line">
                <div class="guide-line-title">
                  {{ item.title }}
                  @if (item.typical) {
                    <span class="preset-tag">Typical</span>
                  }
                </div>
                @if (item.meta) {
                  <div class="guide-line-meta">{{ item.meta }}</div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
  <ng-template #footer>
    <button pButton label="Close" severity="secondary" (click)="close()"></button>
  </ng-template>
</p-dialog>
